import { MetlifeApplyForm } from '../../components/metlife-apply-form/metlife-apply-form';

export const MetlifeApplyPage = () => <MetlifeApplyForm />;
